export default __webpack_public_path__ + "static/scan-to-download-7e8313049cc72619057ee9f997ce78dc.webp";